/** @format */

import React from "react";

import { API_BASE_IMAGES } from "../../OldApp";
import { propertyName } from "../Utils";

const PropertyMapPopup = ({ property, className, onClick }) => {
  // Error/placeholder handled above in PropertyThumbnails loop
  //if (property.ERROR) return PropertyThumbnailError(property);
  //if (property.placeholder) return PropertyThumbnailPlaceholder();

  const photoPath =
    property.photos &&
    property.photos[0] &&
    ((property.photos[0].path_300 &&
      API_BASE_IMAGES + property.photos[0].path_300) ||
      (property.photos[0].path && API_BASE_IMAGES + property.photos[0].path));

  const wrongSizePhoto =
    property.photos && property.photos[0] && !property.photos[0].path_300;

  return (
    <div className={className} onClick={onClick}>
      <div
        className="propertyThumbnailPhoto"
        style={{
          background: `url(${photoPath}) no-repeat, grey`,
          "--aspect-ratio": "1.78",
          border: wrongSizePhoto ? "4px solid pink" : "none",
        }}
      />
      <div className="propertyAddressCard">
        <h3 className="propertyName">{propertyName(property)}</h3>
        <div className="propertyThumbnailAvailability">
          <span className={"blue"} style={{ color: "#296491" }}>
            Click
          </span>{" "}
          for More Information
        </div>
      </div>
    </div>
  );
};

export { PropertyMapPopup };
